<div mat-dialog-title class="flex-container">
    <button mat-button class="close" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
  </button>
    <h1>Add Client</h1>

  </div>
  <div mat-dialog-content>
    <form [formGroup]="_clientForm">
      <div class="row">

          <div class="col-lg-12">
              <p>Enter Client Name <span>*</span></p>
              <mat-form-field appearance="none" class="manage-input">
                <input matInput placeholder="Enter Client Name" formControlName="clientName" required>
              </mat-form-field>
          </div>

          <!-- <div class="col-lg-12">
            <p>Max Call Limit <span>*</span></p>
            <mat-form-field appearance="none" class="manage-input">
              <input matInput placeholder="Max Call Limit" type="number" formControlName="maxCallLimit" required>
            </mat-form-field>
          </div> -->
          <div class="col-lg-12">
            <p>Description</p>
            <mat-form-field appearance="none" class="manage-textarea">
              <textarea matInput placeholder="Enter Client Info" formControlName="clientDesc"></textarea>
            </mat-form-field>
          </div>

          <app-tests *ngIf="tests" [availableTests]="tests" [isEditTests]="false" class="col-lg-12"></app-tests>

          <div class="col-lg-12 toparea">
            <button n-submit mat-raised-button mat-button [disabled]="!_clientForm.valid" (click)="onSubmit()" class="btn btn-icon-text Action-buttons md-button-right">
              ADD CLIENT
          </button>
          </div>

      </div>
    </form>
  </div>
